module.exports = __webpack_public_path__ + "media/img/dowod_rejestracyjny@3x-df9961a0.svg";